import { combineReducers } from 'redux';

import auth from './reducers/auth';
import room from './reducers/room';
import admin from './reducers/admins';
import product from 'store/reducers/product';
import product_type from 'store/reducers/product_type';
import user from 'store/reducers/user';
import appUser from './reducers/appUser';
import cart from 'store/reducers/cart';
import promo from 'store/reducers/promo';
import list from 'store/reducers/list';
import QRcode from 'store/reducers/QRcode';
import inventory from 'store/reducers/inventory';
import setting from 'store/reducers/setting';

export default combineReducers({
  auth,
  admin,
  product,
  product_type,
  user,
  appUser,
  cart,
  promo,
  QRcode,
  inventory,
  list,
  room,
  setting,
});



// WEBPACK FOOTER //
// ./src/store/combineReducers.js